import { render, staticRenderFns } from "./BLayoutEmpty.vue?vue&type=template&id=ddde9f4c&"
import script from "./BLayoutEmpty.vue?vue&type=script&lang=js&"
export * from "./BLayoutEmpty.vue?vue&type=script&lang=js&"
import style0 from "./BLayoutEmpty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VMain,VOverlay,VProgressCircular})
